export default __webpack_public_path__ + "static/1257-977eda8e908d73292182f885ce29c483.gif";